import { LinearProgress } from '@mui/material'
import Grid from '@mui/material/GridLegacy'
import Logo from './Logo'

export function Loading() {
  return (
    <Grid
      container
      spacing={2}
      direction='column'
      alignItems='center'
      justifyContent='center'
      style={{ minHeight: '85vh' }}
    >
      <Grid xs={12} sm={12} md={12} lg={12} item>
        <Logo className='w-24 animate-bounce' />
      </Grid>
      <Grid xs={12} sm={12} md={12} lg={12} item>
        <LinearProgress className='w-60' />
      </Grid>
    </Grid>
  )
}
